export enum SORT_PERIOD {
	Last1Day = 'Today',
	Last7Days = 'Last 7 days',
	Last15Days = 'Last 15 days',
	Last30Days = 'Last 30 days',
}

export const SORT_PERIODS = {
	'1d': SORT_PERIOD.Last1Day,
	'7d': SORT_PERIOD.Last7Days,
	'15d': SORT_PERIOD.Last15Days,
	'30d': SORT_PERIOD.Last30Days,
};
